import { render, staticRenderFns } from "./DocumentLibrary.vue?vue&type=template&id=f88de5ca&scoped=true"
import script from "./DocumentLibrary.vue?vue&type=script&lang=js"
export * from "./DocumentLibrary.vue?vue&type=script&lang=js"
import style0 from "./DocumentLibrary.vue?vue&type=style&index=0&id=f88de5ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88de5ca",
  null
  
)

export default component.exports